import { render, staticRenderFns } from "./Jkhc.vue?vue&type=template&id=601b82e6&scoped=true&"
import script from "./Jkhc.vue?vue&type=script&lang=js&"
export * from "./Jkhc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b82e6",
  null
  
)

export default component.exports